export class GridSwitcher extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.groupsFiltersQuery = null
    this.gridFiltersQuery = null
    this.currentView = 'grid'
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.toggleView = this.toggleView.bind(this)
    this.onFiltersRendered = this.onFiltersRendered.bind(this)

    this.addEventListener('change', this.toggleView)

    if (window.BAO?.eventBus && window.BAO?.EVENTS?.GRID_SWITCHER) {
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.GRID_SWITCHER.RENDER_COMPLETE,
        this.onFiltersRendered,
      )
    }
  }

  toggleView () {
    const checkbox = this.els.checkbox.element

    // Sync all grid-switcher checkboxes
    this.syncAllCheckboxes(checkbox.checked)

    if (checkbox.checked) {
      this.loadGroupedView()
      this.setCurrentView('groups')
    } else {
      this.loadGridView()
      this.setCurrentView('grid')
    }
  }

  syncAllCheckboxes (checked) {
    const allGridSwitchers = document.querySelectorAll('grid-switcher')
    allGridSwitchers.forEach((switcher) => {
      const checkbox = switcher.querySelector(
        '[data-grid-switcher-el="checkbox"]',
      )
      if (checkbox && checkbox !== this.els.checkbox.element) {
        checkbox.checked = checked
      }
    })
  }

  updateAllLabels (text) {
    const allGridSwitchers = document.querySelectorAll('grid-switcher')
    allGridSwitchers.forEach((switcher) => {
      const label = switcher.querySelector(
        '[data-grid-switcher-el="switchLabel"]',
      )
      if (label) {
        label.textContent = text
      }
    })
  }

  updateAllSortSelects (boolean) {
    const allSortSelects = this.externalEls.sortBy?.elements

    allSortSelects?.forEach((element) => {
      if (boolean === true) {
        element.classList.add('clc-ProductGridFacets_Sort-disabled')
      } else {
        element.classList.remove('clc-ProductGridFacets_Sort-disabled')
      }
    })
  }

  setCurrentView (view) {
    this.currentView = view
    document.documentElement.dataset.gridSwitcherView = view
  }

  getCurrentFiltersQuery () {
    const params = new URLSearchParams(window.location.search)

    for (const key of [...params.keys()]) {
      if (!key.startsWith('filter.')) {
        params.delete(key)
      }
    }

    return params.toString()
  }

  onFiltersRendered () {
    const checkbox = this.els.checkbox.element
    const renderGroupedView = checkbox?.checked

    // Sync all checkboxes to match current state
    this.syncAllCheckboxes(renderGroupedView)

    // If the user has the toggle set to grouped, re-apply the grouped view
    if (renderGroupedView) {
      this.loadGroupedView()
      this.setCurrentView('groups')
    } else {
      this.setCurrentView('grid')
    }
  }

  async loadGroupedView () {
    const collectionFilters = this.externalEls.collectionFilters.element
    const collectionHandle = this.dataset.collectionHandle
    const baseContext = `/collections/${collectionHandle}?view=swatch-builder-groups`

    // Preserve active filters when switching to grouped view
    const filtersQuery = this.getCurrentFiltersQuery()

    // Refetch when we don't have a cache yet or filters have changed
    if (!this.groupsContainerDOM || this.groupsFiltersQuery !== filtersQuery) {
      this.groupsFiltersQuery = filtersQuery

      const fetchSection = `&section=`
      const fetchContext = filtersQuery
        ? `${baseContext}&${filtersQuery}`
        : baseContext

      const section = await fetch(`${fetchContext}${fetchSection}`)
      const HTMLText = await section.text()

      collectionFilters.setAttribute('aria-busy', 'true')

      this.groupsContainerDOM =
        window.BAO.sectionRenderer.convertToDOM(HTMLText)
    }

    const groupsElContent = this.groupsContainerDOM.querySelector(
      '[data-collection-filters-el="productList"]',
    )

    const productPanelEl = document.querySelector(
      '[data-collection-filters-el="productList"]',
    )

    collectionFilters.setAttribute('aria-busy', 'false')

    this.updateAllLabels(window.theme.strings.swatchLayoutViewGrouped)

    productPanelEl.innerHTML = groupsElContent.innerHTML

    this.updateAllSortSelects(true)
  }

  async loadGridView () {
    const collectionFilters = this.externalEls.collectionFilters.element
    const collectionHandle = this.dataset.collectionHandle
    const baseContext = `/collections/${collectionHandle}?view=swatch-builder`

    // Preserve active filters when switching back to grid view
    const filtersQuery = this.getCurrentFiltersQuery()

    // Refetch when we don't have a cache yet or filters have changed
    if (!this.gridContainerDOM || this.gridFiltersQuery !== filtersQuery) {
      this.gridFiltersQuery = filtersQuery

      const fetchSection = `&section=`
      const fetchContext = filtersQuery
        ? `${baseContext}&${filtersQuery}`
        : baseContext

      const section = await fetch(`${fetchContext}${fetchSection}`)
      const HTMLText = await section.text()

      collectionFilters.setAttribute('aria-busy', 'true')

      this.gridContainerDOM = window.BAO.sectionRenderer.convertToDOM(HTMLText)
    }

    const gridElContent = this.gridContainerDOM.querySelector(
      '[data-collection-filters-el="productList"]',
    )

    const productPanelEl = document.querySelector(
      '[data-collection-filters-el="productList"]',
    )

    collectionFilters.setAttribute('aria-busy', 'false')

    productPanelEl.innerHTML = gridElContent.innerHTML

    this.updateAllLabels(window.theme.strings.swatchLayoutViewGrid)

    this.updateAllSortSelects(false)
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher)
}
